import { createContext, useContext } from 'react';

export const UsageContext = createContext('apply'); // 'apply', 'add', 'edit', 'preview'
export const getUsageContext = () => useContext(UsageContext);

export const ValidationContext = createContext({});
export const getValidationContext = () => useContext(ValidationContext);
